export const CO2_CLASS_OPTIONS = [
  {value: 'A', label: 'A (0 g/km)'},
  {value: 'B', label: 'B (1-95 g/km)'},
  {value: 'C', label: 'C (96-115 g/km)'},
  {value: 'D', label: 'D (116-135 g/km)'},
  {value: 'E', label: 'E (136-155 g/km)'},
  {value: 'F', label: 'F (156-175 g/km)'},
  {value: 'G', label: 'G (176+ g/km)'},
];
